import { Route, Routes } from "react-router-dom"
import CategorizationGroupONE from './views/CategorizationGroupONE'
import CategorizationGroupTWO from './views/CategorizationGroupTWO'
import CollectionSearch from './views/collection_search'
import CollectionSearchV2 from "./views/collection_search_v2"
import SearchBar from './views/search_bar'
import BibSearchFunction from './views/bib_search_function'
import { Outlet } from 'react-router-dom';
import OnlinePublicCatalogQueryConstructionNews from './views/online_public_catalog_query_construction_news'
import QuestionAndAnswer from "../question_and_answer/views/question_and_answer"
import NewsTypeNew from "../news/views/NewsType"
import New from "../news/views/New"
import LibraryCollectionSearch from '../Library/views/library_collection_search'

const MainRoute = (
    {
        propsPath = "/online_public_catalog_query_construction",
        user_permission_data = []
    }
) => {

    return (<>
        <Routes>
            <Route index element={<BibSearchFunction prefixRoute={'/online_public_catalog_query_construction'}
            />} />
            <Route path='collection_search_old' element={<CollectionSearch />} />
            <Route path='collection_search' element={<CollectionSearchV2 />} />
            <Route path={'categorization_group_one'} element={<CategorizationGroupONE />} />
            <Route path={'categorization_group_two'} element={<CategorizationGroupTWO />} />
            {/* 館藏查詢元件 */}
            <Route path='search_bar' element={<SearchBar />} />
            {/* 館藏查詢頁面 */}
            <Route path='bib_search_function' element={<BibSearchFunction />} />

            {/* <Route index element={<LibraryHome
                otherComponent={
                    [<NewArrivalsListShow />]
                }
            />} /> */}
            <Route path={'question_and_answer'} element={<QuestionAndAnswer permission_level={user_permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "question_and_answer"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
            <Route path='news_type' element={<NewsTypeNew permission_level={user_permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "news_type"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
            <Route path='news' element={<OnlinePublicCatalogQueryConstructionNews
                showChart={false}
                permission_level={user_permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "news"))?.find(data => data !== undefined)?.permission_level_id ?? null}
            />} />

            {/* <Route path='new' element={<New />} /> */}
            {/* <Route path='search' element={<LibrarySearch />} /> */}
            {/* <Route path='search_function' element={<SearchFunction />} /> */}
        </Routes>
        <Outlet />
    </>)
}
export default MainRoute;